"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var normalizePathname_1 = require("./normalizePathname");
var ensureTrailingSlash = function (url) { return normalizePathname_1.stripTrailingSlash(url) + "/"; };
exports.default = ensureTrailingSlash;
